import React, {useEffect, useState} from 'react';
import './FirstPageStyle.scss';
import CarouselImage from '../carouselComponent/CarouselImage';
import ReligiousTimes from '../../islamicTimeAndCalendar/religiousTimes/ReligiousTimes';
import {Link, useNavigate} from 'react-router-dom';
import axiosServise from '../../ApiService';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import IranSanse from "../../Typography/IranSanse.tsx";
import TopMenu from "../../TopMenu/TopMenu.tsx";

const MainMenuItems = () => {
    const [firstMenuItem, setFirstMenu] = useState([]);
    const [secondMenuItem, setSecondMenu] = useState([]);
    //برای گرفتن ایتم منو ها
    useEffect(() => {
        let MenuFromLocalStorage = localStorage.getItem('dataFromLocalStorage');

        if (MenuFromLocalStorage) {
            const mainMenu = localStorage.getItem('mainMenu');
            const subMenu = localStorage.getItem('subMenu');
            setFirstMenu(JSON.parse(mainMenu));
            setSecondMenu(JSON.parse(subMenu));

        } else {
            // debugger
            axiosServise.get(`Menus`).then(response => {
                const responseApi = response.data.content;
                setFirstMenu(responseApi.mainMenu);
                setSecondMenu(responseApi.subMenu);
                localStorage.setItem("dataFromLocalStorage", "true");
                localStorage.setItem("mainMenu", JSON.stringify(responseApi.mainMenu));
                localStorage.setItem("subMenu", JSON.stringify(responseApi.subMenu));
            })
        }
    }, []);

    const nav = useNavigate();

    return (
        <div>
            {/* منو بالا  */}
            <TopMenu Menus={firstMenuItem} OnSelected={(menu) => {
                console.log(menu);
                nav(menu.link === "ShrineNews/" ? '/News' : menu.link)
            }}/>
            <div className={'pt-5'}>
                <CarouselImage/>
            </div>

            <div className='ReligiousTimes-base'>
                <ReligiousTimes/>
            </div>
            <Row className="g-0 pb-5 mx-0 ">
                {
                    secondMenuItem.map(menu => {
                        return (
                            <Col key={menu.id} xl={2} md={3} sm={4} xs={4}
                                 className="pt-5 text-center align-content-center mx-0 px-0">
                                <Row className="g-0">
                                    <Link to={menu.link} className="mx-0 px-0">
                                        <Col className="d-flex justify-content-center">
                                            <div className="footerMenuBox2">
                                                <img
                                                    src={'/Icons/' + `${menu.iconId}` + '.png'}
                                                    alt=""/>

                                             </div>
                                        </Col>
                                    </Link>
                                </Row>
                                <Row className='footerText text-muted text-center g-0'>
                                    <Col className='text-center pt-2'>
                                        <IranSanse>{menu.title}</IranSanse>
                                    </Col>
                                </Row>
                            </Col>
                        )
                    })
                }
            </Row>
        </div>
    )
}

export default MainMenuItems;